import { ChangeEvent, useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody, Col} from "reactstrap";
import TableSearchBar from "./TableSearchBar";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CustomFilteringSearch } from "../../../../Constant";
import { CUSTOM_FILTERING, FILTER_DATA_COLUMN, FILTER_TABLE_DATA } from "../../../../Data/DataTable/CustomFilteringData";
import { DeleteRowDataProp } from "../../../../Type/DataTable";

const CustomFiltering = () => {
  const [first, setfirst] = useState<DeleteRowDataProp[]>([]);
  const [value, setValue] = useState({ minValue: 0, maxValue: 0 });

  const filteredData = (event: ChangeEvent<HTMLInputElement>) => {
    setValue({ ...value, [event.target.name]: event.target.value });
    const filteredData = FILTER_TABLE_DATA.filter((item) => {
      const age = item.age;
      return age >= 30 && age <= 40;
    });
    
    setfirst(filteredData);
  };

  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={CustomFilteringSearch} span={CUSTOM_FILTERING}  />
        <CardBody>
          <TableSearchBar filteredData={filteredData}  />
          <div className="table-responsive user-datatable">
            <div id="datatable-range_wrapper" className="dataTables_wrapper">
              <DataTable data={first} columns={FILTER_DATA_COLUMN} striped highlightOnHover pagination />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CustomFiltering;
